<template>
  <div class="h-full w-full flex flex-col bg-white shadow-lg news-card">
      <div class="w-full relative overflow-hidden">
        <img class="h-56 w-full object-cover" :src="getImage" :alt="item.title" />
        <router-link :to="`/news/${item.id}`" class="read-more absolute bottom-0 right-0 left-0 text-center text-white bg-primary overflow-hidden px-4 py-2">
            Read More
        </router-link>
      </div>
    <div class="flex-auto p-4 flex flex-col">
      <h1 class="text-primaryLight">{{ item.title }}</h1>
      <div class="flex-auto flex flex-col justify-end mt-4">
        <div class="w-full flex justify-between items-end">
          <img
            class="h-8"
            :src="getEntityImage"
            alt="item.entity.entity"
          />
          <p class="text-sm text-slate-500">{{ newsDate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "news-card",
    props: ["item"],
    computed: {
        getImage() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.thumbnail;
        },
        getEntityImage() {
            return process.env.VUE_APP_PUBLIC_URL + this.item.entity.logo;
        },
        newsDate() {
            const parsedDate = new Date(this.item.news_date);
            return parsedDate.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }).replace(/\//g, '-');
        },
    },
}
</script>

<style lang="scss" scoped>
.read-more {
  max-height: 0;
  opacity: 0;
  transition: max-height 1s ease-out, opacity 0.1s ease-out;
}
.news-card:hover .read-more {
  max-height: 100%;
  opacity: 1;
}
.news-card img {
  transition: transform 0.5s ease-out;
}
.news-card:hover img {
  transform: scale(1.05);
}
</style>